import { Contact, Organization } from './orgDomain';
import { PlatformRoleEnum, SiteRoleEnum } from './roleDomain';

export interface Account {
  id: number;
  email: string;
  firstName: string;
  active: boolean;
  lastName: string;
  password: string;
  passwordBrowser: string;
  encryptedPassword: string;
  manageOrgIds: number[];
  token: string;
  tokenType: string;
  org: Organization;
  siteRole: SiteRoleEnum;
  platformRole: PlatformRoleEnum;
  orgId: number;
  manageOrgs: Organization[];
  contacts: Contact[];
  defaultContactId: number;
  userFullName: string;
  balanceBuyerId: string;
  activeLink: string;
  allowSwitchToSourcer: boolean;
  allowSwitchToSupplier: boolean;
  allowAdjustJob: boolean;
  isSSOAccount?: boolean;
  costDistributionConfigMap?: Record<number, UserCostDistributionConfig>;
  canvaUserId?: string;
}

export type PartialAccount = Partial<Account>;

/**
 * Whether the signed-in user's Canva brand (team) is mapped to a RevShop org. An unmapped brand
 * still gets a session, served from the Canva parent org, so it is not the buyer's own org
 * settings that applied. `canvaBrandId` is absent for users who never came from Canva.
 */
export interface CanvaBrandLink {
  canvaBrandId?: string;
  linked: boolean;
}

export interface ListAccountParam {
  offset: number;
  orgId: number;
  page: number;
  size: number;
  paged: boolean;
  unpaged: boolean;
  email: string;
}

export type PartiaListAccountParam = Partial<ListAccountParam>;

export enum EmailChangePasswordTypeEnum {
  resetPassword = 'RESET',
  activateUser = 'ACTIVATE',
}

export const SPECIAL_CHARACTERS = [
  ' ',
  '!',
  '”',
  '#',
  '$',
  '%',
  '&',
  '`',
  '(',
  ')',
  '*',
  '+',
  ',',
  '-',
  '.',
  '/',
  ':',
  ';',
  '<',
  '=',
  '>',
  '?',
  '@',
  '[',
  '\\',
  ']',
  '^',
  '_',
  '`',
  '{',
  '|',
  '}',
  '~',
];

export interface UserInviteParams {
  orgId: number;
  siteRole: SiteRoleEnum;
  platformRole: PlatformRoleEnum;
  email: string;
  company: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface UserCostDistributionConfig {
  orgId: number;
  categories?: UserCostDistributionCategory[];
  oracleSettings?: UserCostDistributionOracleSettings[];
  isManualOracleString?: boolean;
  manualOracleStrings?: string[];
  manualOracleString?: string;
}

export interface UserCostDistributionCategory {
  categoryId?: number;
  categoryName?: string;
  percent?: number;
  subSplits?: UserCostDistributionItem[];
}

export interface UserCostDistributionItem {
  configId?: number;
  siteName?: string;
  percent?: number;
  banner?: string;
  banners?: UserCostDistributionBanner[];
}

export interface UserCostDistributionBanner {
  bannerId?: number;
  bannerName?: string;
  percent?: number;
}
export interface UserCostDistributionOracleSettings {
  oracleString?: string;
  percent?: number;
  banner?: string;
  site?: string;
  siteDesc?: string;
  costCenter?: string;
  costCenterDesc?: string;
  category?: string;
}
